<template>
  <div :class="print.classes">
    <div class="toast-header">
      <strong class="me-auto">
        {{ print.header }}
        <span
          v-if="message.count > 1"
          class="badge bg-secondary"
          >{{ message.count }}</span
        >
      </strong>
      <button
        type="button"
        class="btn-close"
        @click="$emit('close')"
      ></button>
    </div>
    <div class="toast-body">{{ message.message }}</div>
    <div
      class="toast-footer"
      v-if="!permanent"
    >
      <div class="progress">
        <div
          class="progress-bar"
          :style="{ width: progress }"
        ></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.progress {
  height: 0.25rem;
}
</style>
<script setup>
import { computed, onMounted, onUnmounted, shallowRef } from 'vue'

const styling = {
  info: {
    header: null,
    color: 'primary',
  },
  error: {
    header: 'Ошибка',
    color: 'danger',
  },
}

// destroy toast after milliseconds
const destroyTimeout = 5000
const progressTickInterval = 100

let destroyTimeoutId = null
let progressIntervalId = null

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
  permanent: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['close'])
const progressTick = shallowRef(0)
const print = computed(() => {
  const s = styling[props.message.type]
  return {
    header: s.header,
    color: s.color,
    classes: {
      toast: 1,
      show: 1,
      [`text-bg-${s.color}`]: 1,
    },
  }
})
const progress = computed(() => {
  return `${(progressTick.value / destroyTimeout) * 100}%`
})

onMounted(() => {
  if (props.permanent) {
    return
  }
  destroyTimeoutId = setTimeout(() => emit('close'), destroyTimeout)
  progressIntervalId = setInterval(() => {
    progressTick.value += progressTickInterval
  }, progressTickInterval)
})
onUnmounted(() => {
  clearTimeout(destroyTimeoutId)
  clearInterval(progressIntervalId)
  destroyTimeoutId = null
  progressIntervalId = null
})
</script>
